import serviceRequest from "utils/request";

const baseUrl = "/api/file/import";

export const getFileImportRequests = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-file-import-requests`,
		method: "get",
		params,
	});
};

export const getFileImportRequestsRes = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-file-import-requests-res`,
		method: "get",
		params,
	});
};

export const getFileImportDetail = (params) => {
	return serviceRequest({
		url: `${baseUrl}/detail`,
		method: "get",
		params,
	});
};

export const fileImportSubmit = (param) => {
	return serviceRequest({
		url: `${baseUrl}/submit`,
		method: "post",
		data: param,
	});
};

export const fileImportEdit = (param) => {
	return serviceRequest({
		url: `${baseUrl}/edit`,
		method: "post",
		data: param,
	});
};
